import { useAppSelector } from '@/shared/hooks/useStore';
import type { ActivityDrawerViewState } from '@/viewmodel/features/observability/types';
import { selectCurrentWorkspace } from '@/viewmodel/features/workspace';
import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useActivityDrawerViewModel(): ActivityDrawerViewState {
  const [searchParams, setSearchParams] = useSearchParams();
  const workspaceId = useAppSelector(selectCurrentWorkspace)?.id;
  const correlationId = searchParams.get('activity') ?? undefined;

  const close = useCallback(() => {
    const next = new URLSearchParams(searchParams);
    next.delete('activity');
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  return { isOpen: correlationId !== undefined, correlationId, workspaceId, close };
}
